import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus } from '@apollo/client'
import CardWidget, { Colors } from '../../../components/CardWidget'
import CardWidgetSkeleton from '../../../components/skeletons/CardWidgetSkeleton'
import { formatNumber } from '../../../utils/Helpers'
import { EventsFiltersContext } from '../../../context/EventsFiltersContext'
import { FilterEvents } from '../../../types/FilterEvents'
import { GET_UNIQUE_REGISTER_OFFERS } from '../../../queries/events'
import { defaultFormatTimeZone } from '../../../utils/consts'

const QuantityQueue = (): JSX.Element => {
  const { filters } = useContext(EventsFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_UNIQUE_REGISTER_OFFERS, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    let date: FilterEvents['date'] = {
      initialDate: '2021-01-01T03:00:00.000Z',
      finalDate: 'now/d',
      ...defaultFormatTimeZone
    }

    if (filters.date) {
      date = {
        ...filters.date,
        ...defaultFormatTimeZone
      }
    }

    getData({
      variables: { filters: { ...filters, date } }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <CardWidgetSkeleton />
  if (loading || !data) return <CardWidgetSkeleton />
  if (error) return <p>Error :(</p>

  return (
    <CardWidget title="Ofertas cadastro único" number={formatNumber(data.eventOfferIntegrationDatabaseCount)} color={Colors.blue} />
  )
}

export default QuantityQueue
